import { app } from '../../bootstrap/core';
import { customerConfirmState } from './customerConfirm.state';
import { customerConfirmComponent } from './customerConfirm.component';

app.config(customerConfirmState);
app.component(customerConfirmComponent.name, customerConfirmComponent);
